const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/calendar.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/calendar')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface BookingEvent {
  id: string;
  petName: string;
  ownerName: string;
  serviceName: string | null;
  serviceType: string | null;
  scheduledDate: string;
  scheduledTime: string;
  duration: number | null;
  status: string;
  priority: string;
  isEmergency: boolean;
  assignedToMemberId: string | null;
}
interface Member {
  id: string;
  displayName: string | null;
  inviteEmail: string;
}

// Time slots from 8 AM to 8 PM